import { MockedRequest, RestHandler, rest } from "msw";

import { DamagedParts, SignedUrlMetadata } from "pages/VehicleAnalysis/types";

import {
  MOCK_DAMAGED_PARTS_RESPONSE,
  MOCK_POST_UPLOAD_RESPONSE,
  MOCK_SESSION_RESPONSE,
} from "mocks/fixtures/sessionFixtures";
import { ErrorResponse } from "types/ErrorResponse";
import { Session } from "types/Session";

export const getSessionHandler = (
  status: number,
  response: Session | ErrorResponse
): RestHandler<MockedRequest<Session | ErrorResponse>> => {
  return rest.get(`/client/:clientId/session/:sessionId`, (_, res, ctx) => {
    return res(ctx.status(status), ctx.json(response));
  });
};

export const startSessionHandler = (
  status: number,
  response: Session | ErrorResponse
): RestHandler<MockedRequest<Session | ErrorResponse>> => {
  return rest.post(`/client/:clientId/session/:sessionId/start`, (_, res, ctx) => {
    return res(ctx.status(status), ctx.json(response));
  });
};

export const postCreateSignedUrlHandler = (
  status: number,
  response: SignedUrlMetadata | ErrorResponse
): RestHandler<MockedRequest<SignedUrlMetadata | ErrorResponse>> => {
  return rest.post(`/client/:clientId/session/:sessionId/signedUrl`, (_, res, ctx) => {
    return res(ctx.status(status), ctx.json(response));
  });
};

export const postClassifyHandler = (
  status: number,
  response: Session | ErrorResponse
): RestHandler<MockedRequest<Session | ErrorResponse>> => {
  return rest.post(`/client/:clientId/session/:sessionId/classify`, (_, res, ctx) => {
    return res(ctx.status(status), ctx.json(response));
  });
};

export const damagedPartsHandler = (
  status: number,
  response: DamagedParts | ErrorResponse
): RestHandler<MockedRequest<Session | ErrorResponse>> => {
  return rest.get(`/client/:clientId/session/:sessionId/damagedParts`, (_, res, ctx) => {
    return res(ctx.status(status), ctx.json(response));
  });
};

export const sessionCompleteHandler = (
  status: number,
  response: Session | ErrorResponse
): RestHandler<MockedRequest<Session | ErrorResponse>> => {
  return rest.post(`/client/:clientId/session/:sessionId/complete`, (_, res, ctx) => {
    return res(ctx.status(status), ctx.json(response));
  });
};

export const feedbackHandler = (
  status: number,
  response: Session | ErrorResponse
): RestHandler<MockedRequest<Session | ErrorResponse>> => {
  return rest.post(`/client/:clientId/session/:sessionId/feedback`, async (req, res, ctx) => {
    const body: any = await req.json()
    return res(ctx.status(status), ctx.json({...response, rating: body.rating}));
  });
};

export const sessionHandlers = [
  getSessionHandler(200, MOCK_SESSION_RESPONSE),
  startSessionHandler(200, { ...MOCK_SESSION_RESPONSE, startedAt: new Date() }),
  postCreateSignedUrlHandler(200, MOCK_POST_UPLOAD_RESPONSE),
  postClassifyHandler(200, { ...MOCK_SESSION_RESPONSE, classifiedAt: new Date() }),
  damagedPartsHandler(200, MOCK_DAMAGED_PARTS_RESPONSE),
  sessionCompleteHandler(200, { ...MOCK_SESSION_RESPONSE, completedAt: new Date() }),
  feedbackHandler(200, MOCK_SESSION_RESPONSE),
];
